import { Checkbox } from '@focaldata/cin-ui-components'
import React, { useContext } from 'react'
import QuestionnaireContext, {
  selectCard,
  unselectCard
} from '../Questionnaire.context'

export const CardSelector = ({ entryId }: { entryId: string }) => {
  const { questionnaireState, dispatch } = useContext(QuestionnaireContext)
  const handleToggleCardSelection = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isCardSelected = e.target.checked

    dispatch(isCardSelected ? selectCard(entryId) : unselectCard(entryId))
  }
  return (
    <Checkbox
      noPadding
      onChange={handleToggleCardSelection}
      checked={questionnaireState.selectedCards.has(entryId)}
      color="#72758D"
    />
  )
}
